import { Component, OnInit } from '@angular/core';
import { DefaultService } from '../default.service';
import { DashboardService } from './dashboard.service';

@Component({
  selector: 'app-dashboard',
  templateUrl: './dashboard.component.html',
  styleUrls: ['./dashboard.component.scss'],
})
export class DashboardComponent implements OnInit {

  constructor(private defaultService: DefaultService) { }

  ngOnInit() {
    this.defaultService.changeShow(true);

  }

}
